var _ellipse, _ellipse2, _ellipse3, _path, _ellipse4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueSocial(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 40,
    viewBox: "0 0 45 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.8065,
    cy: 6.66634,
    rx: 3.67901,
    ry: 3.33333,
    fill: "#0069FF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 11.8066,
    cy: 13.3333,
    rx: 5.51852,
    ry: 3.33333,
    fill: "#0069FF"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.8807,
    cy: 26.6663,
    rx: 3.67901,
    ry: 3.33333,
    fill: "#0069FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4639 3.33301C21.4639 2.64265 22.0816 2.08301 22.8435 2.08301C33.7648 2.08301 42.6182 10.1046 42.6182 19.9997C42.6182 20.69 42.0005 21.2497 41.2386 21.2497C40.4767 21.2497 39.859 20.69 39.859 19.9997C39.859 11.4853 32.2409 4.58301 22.8435 4.58301C22.0816 4.58301 21.4639 4.02336 21.4639 3.33301ZM4.44848 18.7497C5.21043 18.7497 5.82811 19.3093 5.82811 19.9997C5.82811 28.5141 13.4462 35.4163 22.8435 35.4163C23.6055 35.4163 24.2232 35.976 24.2232 36.6663C24.2232 37.3567 23.6055 37.9163 22.8435 37.9163C11.9223 37.9163 3.06885 29.8948 3.06885 19.9997C3.06885 19.3093 3.68653 18.7497 4.44848 18.7497Z",
    fill: "#0069FF"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 33.8806,
    cy: 33.3333,
    rx: 5.51852,
    ry: 3.33333,
    fill: "#0069FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueSocial);
export default __webpack_public_path__ + "static/media/blueSocial.2809bc934ee1cb5574bcdde3ead44ef8.svg";
export { ForwardRef as ReactComponent };